import {Col, Row} from 'react-bootstrap';
import './styles.css';

const Title = ({children, mainTitle = null, actionButton = null}) => {
  let renderedTitle = (
    <div>
      <h3 className="text-uppercase">
        {children}
      </h3>
    </div>
  );
  if (mainTitle && actionButton) {
    renderedTitle = (
      <Row className="title-with-action">
        <Col lg={8} md={7}>
          <h3 className="text-uppercase">
            {mainTitle}
          </h3>
        </Col>
        <Col lg={4} md={5}>
          {actionButton}
        </Col>
      </Row>
    );
  }

  return renderedTitle;
};

export default Title;
